// extracted by mini-css-extract-plugin
export default {"intro":"app-edit-demands_intro__xCBYI"};